import { useAsyncEffect } from 'ahooks'
import type { ReactNode } from 'react'
import { memo, useMemo, useState } from 'react'
import classNames from 'classnames'
import { wait } from '@/utils/wait'

interface MessageProps {
  className?: string
  icon?: ReactNode
  content?: string
  time?: number
  show: boolean
  onClose?: () => void
}

export const Message = memo((props: MessageProps) => {
  const { className, show, icon, content, time = 3000, onClose } = props
  const [innerShow, setShow] = useState(false)

  useAsyncEffect(async () => {
    if (!show) return
    await wait(time)
    onClose?.()
  }, [show])

  useAsyncEffect(async () => {
    if (show) {
      await wait(10)
      setShow(true)
    } else if (innerShow) {
      await wait(1000)
      setShow(false)
    }
  }, [show])

  const innerClassName = useMemo(() => {
    return classNames(
      className,
      'h-36px w-fit px-16px rounded-6px z-10 bg-#3F3F44 text-#F7F7FF flex flex-center gap-12px duration-300',
      {
        'opacity-0 translate-y-[-12px]': !innerShow || !show,
        'opacity-100 transform-none': show && innerShow,
      },
    )
  }, [show, innerShow])

  if (!show && !innerShow) return null

  return (
    <div className={innerClassName}>
      {icon && <div>{icon}</div>}
      {content && <div>{content}</div>}
    </div>
  )
})
